import gql from 'graphql-tag';

export default gql`
{
  loadingIndicator @client {
    id
    isIndicatorLoading
  }
}
`;
